import React from 'react'
import { renderTextWithNewlines } from '../OracleCommons/renderUtils'
import OracleVoiceModeIcon from '../../icons/OracleVoiceModeIcon'

interface OracleUserMessageProps {
  text: string
  emphasized?: boolean
  mode?: 'text' | 'voice'
}

export const OracleUserMessage: React.FC<OracleUserMessageProps> = ({
  text,
  emphasized = false,
  mode = 'text',
}) => {
  const isVoiceMode = mode === 'voice'

  return (
    <div className="oracle-user-message">
      <div className={`oracle-user-message__bubble ${emphasized ? 'oracle-user-message__bubble--emphasized' : ''} ${isVoiceMode ? 'oracle-user-message__bubble--voice' : ''}`}>
        <div className="oracle-user-message__content">
          <div className={`oracle-user-message__text ${isVoiceMode ? 'oracle-user-message__text--voice' : ''}`}>
            {renderTextWithNewlines(text)}
          </div>
          {isVoiceMode && (
            <div className="oracle-user-message__voice-icon">
              <OracleVoiceModeIcon />
            </div>
          )}
        </div>
        <div className="oracle-user-message__tail">
          {/* The following SVG makes the user message have a cartoon talking bubble */}
          <svg width="27" height="20" viewBox="0 0 27 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M26.4226 19.9995H2.52511L0.787109 9.99951C5.56661 4.33284 15.1256 -4.70049 15.1256 4.49951C15.1256 13.6995 22.6569 18.6662 26.4226 19.9995Z" fill="currentColor" />
          </svg>
        </div>
      </div>
    </div>
  )
}
